import { createMuiTheme } from '@material-ui/core';

export const appTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#009dc7',
    },
    secondary: {
      main: '#009dc7',
    },
  },
});
